import React, { useEffect, useState } from 'react';
import api from '@services/api';
import { Box } from 'vindi-ds-components';
import SecondSectionCard from './second_section_card';
import template from './template.json';

function OnboardInfo() {
  const [data, setData] = useState([]);

  useEffect(() => {
    api.get('/admin/home/guided_onboarding')
      .then((response) => setData(response.data.second_stage));
  }, []);

  const merged = data.map((card, index) => ({
    key: index,
    ...template[card.id],
    ...data[index],
  }));

  return (
    <Box display='flex' flexDirection='column' gridGap='16px' data-testid='onboard_info'>
      {merged.map((cardInfo) => (
        <SecondSectionCard key={cardInfo.key} {...cardInfo} />
      ))}
    </Box>
  );
}

export default OnboardInfo;
